import { render, staticRenderFns } from "./bakatpil.vue?vue&type=template&id=579d2c30&scoped=true"
import script from "./bakatpil.vue?vue&type=script&lang=js"
export * from "./bakatpil.vue?vue&type=script&lang=js"
import style0 from "./bakatpil.vue?vue&type=style&index=0&id=579d2c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579d2c30",
  null
  
)

export default component.exports